module.exports = __webpack_public_path__ + "static/media/Anand Rajagopal.b97348f6.png";